"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RedoSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var RedoSVG = function RedoSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27,2a1,1,0,0,0-1,1v8.272L19.36,4.636A9,9,0,0,0,6.632,17.364L18.975,29.707a1,1,0,1,0,1.414-1.414L8.046,15.95a7,7,0,0,1,9.9-9.9L24.9,13H16a1,1,0,0,0,0,2H26.5A1.5,1.5,0,0,0,28,13.5V3A1,1,0,0,0,27,2Z"
  }));
};
exports.RedoSVG = RedoSVG;
RedoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(RedoSVG);
exports.default = _default;